export class StaticDocuments {
    title: string = '';
    document_path: string = null;
    file_name: string = '';
    is_vet: number = 0;
    is_renew_type: number = 0;
 }